import React, { FC } from 'react';
import { redirectTo, Time } from 'omni-package-react-core';
import { useNavigate } from 'react-router-dom';
import {
  StyledT, StyledButton, StyledTime, StyledDiv,
} from './Section.styles';
import { News } from '../../../interfaces/News';
import Constants from '../../../Constants';

export interface SectionProps {
  news: News;
  isAllNews: boolean;
  currentPage: number;
}

const Section: FC<SectionProps> = ({ news, isAllNews, currentPage }) => {
  const navigate = useNavigate();

  return (
    <StyledButton data-testid={news.id} allNews={isAllNews} onClick={() => { redirectTo(`${Constants.NewsDetailsPagePath}/${news?.id}`, navigate, { currentPage }); }}>
      <StyledDiv>
        <StyledT>{news.title}</StyledT>
        <StyledTime>
          <Time time={new Date(news.activationDate)}></Time>
        </StyledTime>
      </StyledDiv>
    </StyledButton>
  );
};

export default Section;
